import { Card, CardBody, CardHeader, Row, Col } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes = {
  featured_seller: PropTypes.shape({
    inspired_look: PropTypes.shape({
      hero_image_url : PropTypes.string,
      outfits        : PropTypes.array
    }),
    favourite_brand_thumbnail_image_url : PropTypes.string,
    main_page_thumbnail_image_url       : PropTypes.string
  })
}

const defaultProps = {
  featured_seller: {
    inspired_look: {
      hero_image_url : '',
      outfits        : [
        {
          title         : 'Title',
          image_url     : '',
          description   : 'description',
          collection_id : ''
        }
      ]

    }
  },
  favourite_brand_thumbnail_image_url : '',
  main_page_thumbnail_image_url       : ''

}

function CmsFeaturedSellerInspiredLookPreviewSection({
  featured_seller
}) {
  return (
    <Card>
      <CardHeader>
        <h2>PREVIEW</h2>
      </CardHeader>
      <CardBody>
        <Row>
          <Col lg='12' style={{ backgroundColor: 'gray' }}>
            <h3 className='text-center'>Header</h3>
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col lg='12' className='p-0' style={{ minHeight: '150px', backgroundColor: 'aqua', textAlign: 'center' }}>
            {
              featured_seller.inspired_look.hero_image_url ?
                <img src={ `${featured_seller.inspired_look.hero_image_url}` } style={{ width: '100%' }} alt=''/>
                :
                <h3 className='text-center' style={{ paddingTop: '55px' }}>Cover Image</h3>
            }
          </Col>
        </Row>
        {
          featured_seller.inspired_look.outfits.map((outfit, index) => <Row key={ `outfit-${index}` } className='mt-4'>
            <Col lg='12'>
              <Row>
                <Col lg='5'>
                  <h3 className='text-left'>{ `Outfit-${index+1}` }</h3>
                </Col>
                <Col lg='3'>
                  <h3 className='text-left'>{ outfit.title }</h3>
                </Col>
              </Row>
              <Row>
                <Col lg='12'>
                  {
                    outfit.image_url ?
                      <img src={ `${outfit.image_url}` } style={{ width: '100%' }} alt=''/>
                      :
                      <h3 className='text-center' style={{ marginLeft: '155px', marginRight: '155px', padding: '30px', border: '1px solid black' }} >Image</h3>
                  }
                </Col>
              </Row>
              <Row>
                <Col lg='12'>
                  <h3 className='text-center' style={{ marginLeft: '0px', marginRight: '0px', padding: '30px', fontSize: '12px', marginTop: '10px', backgroundColor: '#f5f5f5', height: '100%', marginBottom: '30px' }} >{ outfit.description }</h3>
                </Col>
              </Row>
              <Row>
                <Col lg='12'>
                  <h3 className='text-center' style={{ marginLeft: '0px', marginRight: '0px', backgroundColor: 'orange' }} >Product Collection</h3>
                </Col>
              </Row>
            </Col>
          </Row>
          )
        }

        <Row className='mt-4'>
          <Col lg='6' className='p-0' style={{ height: '100px', backgroundColor: 'aqua' }}>
            {
              featured_seller.main_page_thumbnail_image_url ?
                <img src={ `${featured_seller.main_page_thumbnail_image_url}` } style={{ width: '100%' }} alt=''/>
                :
                <h3 className='text-center' style={{ paddingTop: '25px' }}>Main Page Thumbnail Image</h3>
            }
          </Col>
          <Col lg='6'className='p-0' style={{  height: '100px', backgroundColor: '#00ff4e' }}>
            {
              featured_seller.favourite_brand_thumbnail_image_url ?
                <img src={ `${featured_seller.favourite_brand_thumbnail_image_url}` } style={{ width: '100%' }} alt=''/>
                :
                <h3 className='text-center' style={{ paddingTop: '25px', paddingBottom: '10px' }}>Inspired Look Thumbnail Image</h3>
            }
          </Col>
        </Row>
        <Row className='mt-4'>
          <Col lg='12' style={{ height: '30px', backgroundColor: 'gray', marginTop: '120px' }}>
            <h3 className='text-center'>Footer</h3>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )

}

CmsFeaturedSellerInspiredLookPreviewSection.propTypes    = propTypes
CmsFeaturedSellerInspiredLookPreviewSection.defaultProps = defaultProps

export default CmsFeaturedSellerInspiredLookPreviewSection
